// Floating Logo Component
// Animated Revolt logo for the hero section

export function FloatingLogo() {
  return (
    <img
      src="https://bluedrake42.nyc3.cdn.digitaloceanspaces.com/revolt-site/site-assets/logo/revolt-logo-small-transparent.png"
      alt="Revolt"
      className="landing-logo"
    />
  );
}
